import { Directive, Input } from '@angular/core';

/** Default text shown on every platform when a typeahead's remote search failed. */
export const DYNAMIC_SEARCH_ERROR_DEFAULT_MESSAGE =
  'Unable to load results. Check your connection and try again.';

/**
 * Platform-agnostic state for the non-blocking typeahead search-failure notice.
 *
 * Each typeahead binds its inherited `searchError` getter (backed by the control's
 * `hasSearchError_dynamic` flag) to `show`. Web and NativeScript only supply the
 * template, so the wording and show/hide rule cannot drift between platforms.
 * It touches no form control, so it never invalidates the form.
 */
@Directive()
export abstract class DynamicSearchErrorBaseComponent {
  /** True when the last remote search for this control threw. */
  @Input() show = false;

  /** Optional override for the default failure message. */
  @Input() message?: string;

  readonly defaultMessage = DYNAMIC_SEARCH_ERROR_DEFAULT_MESSAGE;

  /** The message to render: the override when set, otherwise the default. */
  get resolvedMessage(): string {
    return this.message || this.defaultMessage;
  }
}
